// AUTO-GENERATED at build time by set-build-info.js (see frontend/Dockerfile).
// This committed copy is the local-dev fallback; the Docker image overwrites it
// with the real commit hash, version (from the release tag), and build date.
export const buildInfo = {
  commit: 'adf214c',
  version: '1.5.17-33-gadf214c0',
  buildDate: '2026-10-30T14:10:34.365Z',
};
